import { useEffect } from 'react';
import { refreshKyc, UserProfile } from '../api/api';
import { useApp } from '../context/AppContext';

const inFlightByToken = new Map<string, Promise<UserProfile>>();

export function shouldAutoRefreshKyc(user: UserProfile | null): boolean {
  if (!user || user.isSbpVerified || user.kycStatus === 'Approved') return false;
  return user.kycStatus !== 'NotStarted' && user.kycStatus !== 'ProfileIncomplete';
}

export function useKycAutoRefresh() {
  const { token, user, setUser } = useApp().userAuth;
  const shouldRefresh = shouldAutoRefreshKyc(user);

  useEffect(() => {
    if (!token || !shouldRefresh) return;

    let cancelled = false;
    let request = inFlightByToken.get(token);
    if (!request) {
      request = refreshKyc(token).finally(() => inFlightByToken.delete(token));
      inFlightByToken.set(token, request);
    }
    request
      .then(user => {
        if (!cancelled) setUser(user);
      })
      .catch(() => {
        // Ошибка фонового обновления не должна блокировать профиль или пополнение.
      });

    return () => {
      cancelled = true;
    };
  }, [token, shouldRefresh, setUser]);
}
